<template>
  <div :class="theme">
    <transition name="component-fade" mode="out-in" v-if="isAuthenticated && !isRouteWithHiddenNav">
      <component :is="navShell">
        <router-view />
      </component>
    </transition>
    <router-view v-else v-slot="{ Component }">
      <transition name="component-fade" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>
    <portal-version-switch v-if="isAuthenticated && !isPortalV2 && !isRouteWithHiddenNav" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import NewNavigationWrap from "@/components/v2/NavigationWrap.vue";
import NavigationWrapV2 from "@/components/v2/NavigationWrapV2.vue";
import PortalVersionSwitch from "@/components/PortalVersionSwitch.vue";

export default {
  components: {
    NewNavigationWrap,
    NavigationWrapV2,
    PortalVersionSwitch,
  },
  computed: {
    ...mapGetters("cognito", ["isAuthenticated"]),
    ...mapGetters("organization", ["organization", "cobrandId", "isPortalV2"]),
    navShell() {
      return this.isPortalV2 ? "navigation-wrap-v2" : "new-navigation-wrap";
    },
    isRouteWithHiddenNav() {
      return this.$route.path === "/" || this.$route.meta.hideNav;
    },
    theme() {
      switch (this.cobrandId) {
        case "rx-harmony":
          return "theme-rx-harmony";
      }

      return "";
    },
  },
  watch: {
    "$route.query.cobrand": {
      immediate: true,
      handler() {
        if (this.$route.query.cobrand) {
          this.$store.commit("organization/setCobrand", this.$route.query.cobrand);
        }
      },
    },
    cobrandId: {
      immediate: true,
      handler() {
        switch (this.cobrandId) {
          case "rx-harmony": {
            const favicon = document.getElementById("favicon");
            favicon.href = "/favicon-rx-harmony.ico";

            const title = document.getElementById("app-title");
            title.textContent = "Rx Harmony";

            const applIcon = document.getElementById("apple-touch-icon");
            applIcon.href = "/apple-touch-icon-rx-harmony.png";

            break;
          }
          default: {
            const favicon = document.getElementById("favicon");
            favicon.href = "/favicon.ico";

            const title = document.getElementById("app-title");
            title.textContent = "Predictile";
          }
        }
      },
    },
  },
};
</script>

<style src="@/assets/main.css"></style>

<style lang="scss">
@import "@/assets/styles/base.scss";

.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}
.component-fade-enter-from,
.component-fade-leave-to {
  opacity: 0;
}

// Vue Select
li.vs__dropdown-option.vs__dropdown-option--selected,
li.vs__dropdown-option.vs__dropdown-option--highlight {
  background-color: var(--primary-100);
  color: #404040;
}

//datepicker
.dp__theme_light {
  --dp-primary-color: var(--primary-500);
  --dp-primary-text-color: #fff;
  --dp-secondary-color: var(--primary-100);
  --dp-hover-color: var(--primary-50);
}

:root {
  --primary-DEFAULT: #ff0090;
  --primary-50: #ffe5f4;
  --primary-100: #ffcce9;
  --primary-200: #ff99d3;
  --primary-300: #ff66bc;
  --primary-400: #ff33a6;
  --primary-500: #ff0090;
  --primary-600: #cc0073;
  --primary-700: #990056;
  --primary-800: #66003a;
  --primary-900: #33001d;

  --green-50: #f0fdf4;
  --green-100: #dcfce7;
  --green-200: #bbf7d0;
  --green-300: #86efac;
  --green-400: #4ade80;
  --green-500: #22c55e;
  --green-600: #16a34a;
  --green-700: #15803d;
  --green-800: #166534;
  --green-900: #14532d;

  --navbar-bg: #111827 !important;
  --logo-bg: #ffffff !important;
}

.theme-rx-harmony {
  --primary-DEFAULT: #52ba46 !important;
  --primary-50: #edf8ee !important ;
  --primary-100: #e3fae3 !important;
  --primary-200: #b6e4b5 !important;
  --primary-300: #93d690 !important;
  --primary-400: #71c86b !important;
  --primary-500: #52ba46 !important;
  --primary-600: #4dad3e !important;
  --primary-700: #338522 !important;
  --primary-800: #164709 !important;
  --primary-900: #0c3301 !important;

  --green-DEFAULT: #52ba46 !important;
  --green-50: #edf8ee !important ;
  --green-100: #e3fae3 !important;
  --green-200: #b6e4b5 !important;
  --green-300: #93d690 !important;
  --green-400: #71c86b !important;
  --green-500: #52ba46 !important;
  --green-600: #4dad3e !important;
  --green-700: #338522 !important;
  --green-800: #164709 !important;
  --green-900: #0c3301 !important;

  --color-primary: #52ba46 !important;
  --color-primary-50: #edf8ee !important;
  --color-primary-100: #e3fae3 !important;
  --color-primary-200: #b6e4b5 !important;
  --color-primary-300: #93d690 !important;
  --color-primary-400: #71c86b !important;
  --color-primary-500: #52ba46 !important;
  --color-primary-600: #4dad3e !important;
  --color-primary-700: #338522 !important;
  --color-primary-800: #164709 !important;
  --color-primary-900: #0c3301 !important;

  --color-green-50: #edf8ee !important;
  --color-green-100: #e3fae3 !important;
  --color-green-200: #b6e4b5 !important;
  --color-green-300: #93d690 !important;
  --color-green-400: #71c86b !important;
  --color-green-500: #52ba46 !important;
  --color-green-600: #4dad3e !important;
  --color-green-700: #338522 !important;
  --color-green-800: #164709 !important;
  --color-green-900: #0c3301 !important;

  --navbar-bg: #55b948 !important;
  --logo-bg: #55b948 !important;

  .st0 {
    fill: #003d1e;
  }

  .st1 {
    fill: #ffffff;
  }
}
</style>
